<template>
  <div>
    <div class="main1_position" v-show="this.list_two == 1"></div>
    <div class="main1_warp">
      <!-- 查询框 -->
      <div class="main1" v-show="this.list_two == 1" id="main_btn">
        <el-button type="primary" @click="back">{{
          $t("list.return")
        }}</el-button>
        <el-button
          @click="xiazai"
          :disabled="$root.jurisdiction.only_query == 0"
          v-if="this.authority_to_judge.download_message == 1"
          >{{ $t("list.download") }}</el-button
        >
        <!-- 上报垃圾-->
        <el-button
          v-if="this.readmsg_show == 1"
          @click="report_msg"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("logs.as_spam") }}</el-button
        >
        <!-- <el-button @click="pass">{{$t("list.pass")}}</el-button>-->
        <el-button
          @click="dawdata"
           :disabled="$root.jurisdiction.only_query == 0"
          v-if="this.authority_to_judge.rawdata == 1"
          >{{ $t("list.rawdata") }}</el-button
        >
        <el-button @click="header"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.header") }}</el-button>
        <!-- <el-button @click="reason">{{$t("list.whyspam")}}</el-button>-->
        <el-button
          @click="abstract"
           :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0"
          v-if="
            this.abstract_show == 1 && this.authority_to_judge.show_digest == 1
          "
          >{{ $t("list.show") }}</el-button
        >
        <el-button
          @click="matter"
           :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0"
          v-if="
            this.abstract_show == 1 && this.authority_to_judge.show_digest == 1
          "
          >{{ $t("list.body") }}</el-button
        >
        <el-button
          @click="original"
           :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0"
          v-if="
            this.original_show == 1 &&
            this.authority_to_judge.printoriginalbody == 1
          "
          >{{ $t("list.origin") }}</el-button
        >
        <el-button
          @click="print"
           :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0" 
          v-if="
            this.print_show == 1 &&
            this.authority_to_judge.printparticipleinfo == 1
          "
          >{{ $t("list.info") }}</el-button
        >
         <!-- 详细信息 -->
         <el-button
          @click="detail_click_show"
           :disabled="$root.jurisdiction.only_query == 0 "
         
          >{{ $t("list.detail") }}</el-button
        >
        <el-button
          v-if="this.trainspam_show == 1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.trainspam") }}</el-button
        >
        <el-button
          v-if="this.trainspam_show == 1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.trainnormal") }}</el-button
        >
        <el-button
          v-if=" this.authority_to_judge.delete == 1"
          @click="readmsg_sum"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("logs.Conditional8") }}</el-button
        >

        <el-button type="text" @click="up_email">{{
          $t("logs.up_mail1")
        }}</el-button>
        <el-button type="text" @click="next_email">{{
          $t("logs.next_mail1")
        }}</el-button>
      </div>
    </div>
    <div class="xin" id="detail_type">
      <div class="swicth" v-show="this.list_first == 1">
        <!-- 查询框 -->
        <div class="main">
          <el-form ref="form" label-width="80px">
            <ul>
              <li>{{ $t("wasteInsulate1.envfrom") }}:</li>
              <el-input placeholder v-model="col.envfrom" clearable></el-input>
              <li>{{ $t("wasteInsulate1.envrcpt") }}:</li>
              <el-input placeholder v-model="col.envrcpt" clearable></el-input>
              <li>{{ $t("wasteInsulate1.subject") }}:</li>
              <el-input placeholder v-model="col.subject" clearable></el-input>
              <li>{{ $t("wasteInsulate1.ip") }}:</li>
              <el-input placeholder v-model="col.ip" clearable></el-input>
              <el-button @click="tanSend">{{ $t("table.search") }}</el-button>
              <el-button
                @click="xians()"
                v-show="geng"
                type="text"
                class="more_s"
                >{{ $t("table.more") }}
              </el-button>
              <el-button
                @click="xians()"
                v-show="geng1"
                type="text"
                class="more_d"
                >{{ $t("table.more1") }}</el-button
              >
            </ul>
          </el-form>
          <div class="search" v-show="xian">
            <ul>
              <li>{{ $t("wasteInsulate1.hdrfrom") }}:</li>
              <el-input placeholder v-model="col.hdrfrom" clearable></el-input>

              <li>{{ $t("wasteInsulate1.hdrto") }}:</li>

              <el-input placeholder v-model="col.hdrto" clearable></el-input>
              <li>{{ $t("wasteInsulate1.attach") }}:</li>
              <el-input placeholder v-model="col.attach" clearable></el-input>
              <li>{{ $t("wasteInsulate1.attnum") }}:</li>
              <el-input placeholder="" v-model="col.nbattach">
                <el-select v-model="col.achunit" slot="prepend" placeholder="">
                  <el-option label=">=" value="1"></el-option>
                  <el-option label="<=" value="2"></el-option>
                  <el-option label="=" value="3"></el-option>
                </el-select>
              </el-input>
            </ul>
           
            <ul>
              <li>{{ $t("wasteInsulate1.bigs") }}:</li>
              <div class="mailSize">
                <el-input v-model="col.min_size"></el-input>
                <el-select v-model="col.min_size_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option> </el-select
                >{{ $t("wasteInsulate1.zhi") }}
                <el-input v-model="col.max_size"></el-input>
                <el-select v-model="col.max_size_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <li>{{ $t("wasteInsulate1.attachment_size") }}:</li>
              <div class="mailSize">
                <el-input v-model="col.min_attsize"></el-input>
                <el-select v-model="col.min_attsize_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option> </el-select
                >{{ $t("wasteInsulate1.zhi") }}
                <el-input v-model="col.max_attsize"></el-input>
                <el-select v-model="col.max_attsize_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <li style="width: 40px">{{ $t("tab.sort") }}:</li>

              <el-select
                v-model="col.q_order_type"
                slot="prepend"
                placeholder=""
                style="width: 10%; padding-right: 0px"
              >
                <el-option
                  v-for="item in q_order_type_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="col.q_order_sort"
                slot="prepend"
                placeholder=""
                style="width: 7%; padding-left: 0px"
              >
                <el-option
                  v-for="item in q_order_sort_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </ul>
            <ul>
              <li>{{ $t("wasteInsulate1.startdate") }}:</li>
              <el-date-picker
                v-model="col.startdate"
                type="datetimerange"
                :range-separator="$t('wasteInsulate1.zhi')"
                :start-placeholder="$t('table.sdata')"
                :end-placeholder="$t('table.enddata')"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </ul>
          </div>
        </div>

        <!--  表格 -->

        <div class="table">
          <el-table
            v-loading="loading"
            :data="fileList1"
            :row-class-name="tableRowClassName"
            ref="multipleTable"
            tooltip-effect="dark"
            style="width: 100%"
            highlight-current-row
            @selection-change="handleSelectionChange"
            :row-key="getRowKeys"
            @cell-click="addSubAccount"
           
              @sort-change="sortChangeEvent"
          >
            <el-table-column
              type="selection"
              width="40"
              :reserve-selection="true"
              v-model="multipleSelection"
            ></el-table-column>
            <el-table-column :label="$t('table.tls')" width="40" v-if="this.ping_an_show==0">
              <template slot-scope="scope" v-if="ping_an_show==0">
                <img v-if="scope.row.SHOWTLS == 0" src="/imgs/tls2.png" alt />
                <img
                  v-if="scope.row.SHOWTLS == 1"
                  src="/imgs/tls.png"
                  alt
                  title="tls"
                />
                <img
                  v-if="scope.row.SHOW_WL == 1"
                  src="/imgs/wls.png"
                  alt
                  :title="$t('table.wl')"
                />
                <img v-if="scope.row.SHOW_WL == 0" src="/imgs/wls2.png" alt />
              </template>
            </el-table-column>
            <el-table-column
              prop="AC_DATE"
              :label="$t('table.maildate')"
              width="100"
              sortable="custom"
            >
            </el-table-column>
           
           
         
            <el-table-column
             sortable="custom"
              prop="ENVFROM"
              :label="$t('table.ENVFROM')"
            
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.ENVFROM"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_ENVFROM }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
             sortable="custom"
              prop="ENVRCPT"
              :label="$t('table.ENVRCPT')"
             
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.SHOW_MORE_RCPT"
                  placement="top"
                >
                  <span> {{ scope.row.ENVRCPT }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')">
              <template slot-scope="scope">
                <el-tooltip
                  popper-class="tooltio_subject"
                  class="item tooltio_subject"
                  effect="dark"
                  :content="scope.row.SUBJECT"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_SUBJECT }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              prop="SIZE"
              :label="$t('table.mailsize')"
              width="62"
            ></el-table-column>
          </el-table>
        </div>

        <!--  分页 -->
        <div class="fenye" v-show="xian6">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalnums"
          ></el-pagination>
          <button
            @click="openPostWindow"
            class="el-icon-download1"
            v-if="this.authority_to_judge.download_message == 1"
            :disabled="$root.jurisdiction.only_query == 0"
          >
            {{ $t("table.download") }}
          </button>

          <!-- <button @click="bulkpass" class="el-icon-finished1">{{
              $t("table.pass1")
            }}</button>-->
          <button
            @click="data_delete"
            class="el-icon-del1"
            :disabled="$root.jurisdiction.only_query == 0"
            v-if="
             
              this.authority_to_judge.delete == 1
            "
          >
            {{ $t("table1.delete") }}
          </button>
          <el-dropdown
            trigger="click"
            class="collect"
           
          >
            <span
              class="el-dropdown-link"
              style="color: #006be7; margin-left: 10px"
              
            >
              {{ $t("table.more_operations")
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown" class="show_style_drop" >
              <ul
                class="tanchu_style"
                v-if="this.archive_forward_show == 1"
                 @click="archive_forward_tanchu"
                
              >
                <el-dropdown-item command=""  
               >
                  {{ this.data_forword }}
                </el-dropdown-item>
              </ul>
              <!-- 导出 -->
              <ul class="tanchu_style"  @click="derived_record" >
                <el-dropdown-item command=""  >
                  {{ $t("table1.export_email") }}
                </el-dropdown-item>
              </ul>
            </el-dropdown-menu>
          </el-dropdown>
             <div class="pop-up " v-show="derived_show"  v-drag="{ handle: '.pop_up_text_derived_record' }"
            >
              <!--  导出框-->
              <div class="pop_up_text pop_up_text_derived_record">
                <span style="padding:0 14px"></span>{{ $t("table.record") }}
              </div>
              <p></p>
              <div class="find">
               
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 条数 -->
                    {{ $t("logs.derived") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="limit_cn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 类型 -->
                    {{ $t("logs.smtpIp6") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="printtype"
                      placeholder=""
                     
                    >
                      <el-option
                        v-for="item in printtype_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                
                
               
                
               
               
              </div>

              <el-row>
                <el-button type="primary" @click="derived_unit">{{
                  $t("logs.report16")
                }}</el-button>
                <el-button type="danger" @click="derived_cancel">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="derived_show"></div>
        </div>
      </div>
      <!-- 归档转发 -->
      <div
        class="pop-up pop-up1"
        v-show="tanchu_forward"
        v-drag="{ handle: '.pop_up_text_relay_domain' }"
      >
        <div class="pop_up_text pop_up_text_relay_domain">
          <span class="span_pad"></span>{{ this.data_forword }}
        </div>
        <p></p>
        <div class="find">
          <div class="find1">
            <div class="find-text" style="padding-right: 12px">
              {{ this.data_forword }}:
            </div>
            <div class="block block1" style="display: flex">
              <el-input v-model="forword_email" style="width: 100%"></el-input>
            </div>
          </div>
        </div>

        <el-row>
          <el-button type="primary" @click="save_archiveforward()">{{
            $t("logs.transmit")
          }}</el-button>
          <el-button type="danger" @click="tanOff_archive_forward()">{{
            $t("tab.cancel")
          }}</el-button>
        </el-row>
      </div>
      <div class="gray" v-show="tanchu_forward"></div>
      <div
        class="xin1"
        v-loading="loading"
        v-show="this.list_two == 1"
        id="main_btn1"
      >
        <div class="swicth">
          <!-- 内容区域 -->
          <div class="cent">
            <!-- 分词信息 -->

            <ol class="reason" v-show="print2">
              <li>
                {{ $t("list.info") }}:<el-button @click="yin4">{{
                  $t("list.hide")
                }}</el-button>
              </li>

              <el-input type="textarea" :rows="10" v-model="print1"> </el-input>
            </ol>
            <!-- 原始正文 -->

            <ol class="reason" v-show="original2">
              <li>
                {{ $t("list.origin") }}:<el-button @click="yin3">{{
                  $t("list.hide")
                }}</el-button>
              </li>

              <el-input type="textarea" :rows="10" v-model="original1">
              </el-input>
            </ol>
              <!-- 详细信息 -->

            <ol class="reason" v-show="detail_show">
              <li>
                {{ $t("list.detail") }}:<el-button @click="yin_detail">{{
                  $t("list.hide")
                }}</el-button>
              </li>

              <el-input type="textarea" :rows="10" v-model="detail_info">
              </el-input>
            </ol>
            <!-- 正文分析 -->

            <ol class="reason" v-show="matter2">
              <li>
                {{ $t("list.body") }}:<el-button @click="yin2">{{
                  $t("list.hide")
                }}</el-button>
              </li>
              <li v-html="matter1"></li>
            </ol>
            <!-- 显示摘要 -->

            <ol class="reason" v-show="abstract2">
              <li>
                {{ $t("list.show") }}:<el-button @click="yin1">{{
                  $t("list.hide")
                }}</el-button>
              </li>
              <li v-html="abstract1"></li>
            </ol>
            <!-- 原因分析 -->
            <ol class="reason" v-show="reason2">
              <li>
                {{ $t("list.whyspam") }}:<el-button @click="yin">{{
                  $t("list.hide")
                }}</el-button>
              </li>

              <li style="white-space: pre-wrap">{{ reason1 }}</li>
            </ol>
            <!-- 来自 -->
            <p v-html="fileList.SUBJECT"></p>

            <ul>
              <li>{{ $t("list.from") }}:</li>
              <li>
                {{ fileList.FROMNAME }}
                <span class="list_text">{{ fileList.FROMADDR }}</span>
              </li>
            </ul>
            <ul>
              <li>{{ $t("list.to") }}:</li>
              <li class="list_text">{{ fileList.TO }}</li>
            </ul>
            <ul v-if="this.fileList.CC">
              <li>{{ $t("list.cc") }}:</li>
              <li>{{ fileList.CC }}</li>
            </ul>

            <!-- 日期 -->
            <ul>
              <li>{{ $t("list.data") }}:</li>
              <li class="list_text">{{ fileList.DATE }}</li>
            </ul>
            <ul v-if="fileList.ATTACHMENT == 1">
              <li>{{ $t("list.attach") }}:</li>
              <li class="yichu">
                ({{ fnameage }} {{ $t("list.num") }} ){{ fname }}
              </li>
            </ul>
            <ul>
              <li>{{ $t("list.envfrom") }}:</li>
              <li>
                {{ fileList.ENVFROM }}
              </li>
              <li v-if="fileList.ADD_BLACK_EMAIL_IN_SPAM == 1">
                <el-button @click="tan1"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bte") }}</el-button>
              </li>
              <li v-if="fileList.BLACK_EMAIL_IS_IN_SPAM == 1">
                {{ $t("tan.bte") }}
                <el-button @click="tan11"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bte1") }}</el-button>
              </li>
              <li v-if="fileList.DELETE_WHITE_EMAIL_IN_SPAM == 1">
                {{ $t("tan.wte") }}
                <el-button @click="tan12"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.wte1") }}</el-button>
              </li>
            </ul>
            <ul>
              <li>{{ $t("list.envrcpt") }}:</li>
              <li>{{ fileList.ENVRCPT }}</li>
            </ul>

            <ul>
              <li>{{ $t("list.id") }}:</li>
              <li>{{ fileList.QUEUE_ID }}</li>
            </ul>
            <ul>
              <li>{{ $t("list.ip") }}:</li>
              <li>
                {{ fileList.PEER_IP }}
              </li>
              <li v-if="fileList.ADD_BLACK_IP_IN_SPAM == 1">
                <el-button @click="tan3"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bti") }}</el-button>
              </li>
              <li v-if="fileList.DELETE_BLACK_IP_IN_SPAM == 1">
                {{ $t("tan.bti1")
                }}<el-button @click="tan13"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bti1") }}</el-button>
              </li>
              <li v-if="fileList.DELETE_WHITE_IP_IN_SPAM == 1">
                {{ $t("tan.wti1") }}
                <el-button @click="tan14"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.wti1") }}</el-button>
              </li>
            </ul>
            <ul v-if="this.fileList.REPLY_TO_ADDR">
              <li>replyto:</li>
              <li>
                {{ fileList.REPLY_TO_NAME
                }}<span style="color: #818ea8; margin-left: 4px"
                  >&lt;{{ fileList.REPLY_TO_ADDR }}&gt;</span
                >
              </li>
            </ul>
            <ul v-if="this.fileList.SENDER_ADDR">
              <li>Sender:</li>
              <li>
                {{ fileList.SENDER_NAME
                }}<span style="color: #818ea8; margin-left: 4px"
                  >&lt;{{ fileList.SENDER_ADDR }}&gt;</span
                >
              </li>
            </ul>
          </div>

          <!-- 展示 -->
          <div
            class="cent2"
            v-html="html"
            v-if="this.authority_to_judge.see_body == 1"
          ></div>
          <!-- 附件 -->
          <div class="footer" v-if="fileList.ATTACHMENT == 1">
            <p>
              <img src="/imgs/fujian.png" alt />
              {{ $t("list.fu") }}({{ fnameage }} {{ $t("list.num") }})
            </p>
            <div v-for="v in fujian" :key="v.id">
              <img :src="`/imgs/${v.FILETYPE}.png`" alt />
              <ul>
                <li>{{ v.NAME }}({{ v.HSIZE }})</li>
                <li @click="down(v.CNT)"  >{{ $t("list.download") }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { garbageVirus } from "../../tool/elk_virus.js";
import { readmsg } from "../../tool/readmsg.js";
export default {
  mixins: [garbageVirus,readmsg],
  data() {
    return {
       limit_cn_old:'',
       limit_cn:'',
      printtype:'pdf',
      printtype_arr:[],
      derived_show:false,
      reserve_selection: true,
      forword_email: "",
      tanchu: false,
      all_show_more_show: "",
      data_can_delete_show: "",
      all_download_show: "",
      again_the_delivery_show: "",
      again_the_delivery_hint: "",
      archive_forward_show: "",
      archive_forward_address: "",
      all_download: "",
      again_the_delivery: "",
      archive_forward: "",
      search_time: 0,
      delect_show: "",
      print_show: "",
      original_show: "",
      abstract_show: "",
      trainspam_show: "",
      readmsg_show: "",
      subwhy: "",
      list_first: 1,
      list_two: 0,
      details: {},
      fileList: [],
      fujian: [],
      fujian1: [],
      html: "",
      html1: "",
      loading: true,
      // 原因分析
      reason1: "",
      reason2: false,
      // 显示摘要
      abstract1: "",
      abstract2: false,
      // 正文分析
      matter1: "",
      matter2: false,

      // 原始正文
      original1: "",
      original2: false,

      // 分词信息
      print1: "",
      print2: false,
      // 附件名
      fname: "",
      // 附件个数
      fnameage: 0,
      // 判断加入还是移出黑名单
      pan1: true,
      // 只可以选择今天之前的日期
      pickerOptions: {
        disabledDate(time) {
          var todayYear = new Date().getFullYear();
          var todayMonth = new Date().getMonth();
          var todayDay = new Date().getDate();
          var todayTime = new Date(
            todayYear,
            todayMonth,
            todayDay,
            "23",
            "59",
            "59"
          ).getTime(); // 毫秒

          return time.getTime() > todayTime;
        },
      },
      // 查找
      // 查询条件
      col: {
        q_order_type: "datetime",
        q_order_sort: "desc",
        linkunit: "1",
        bccunit: "1",
        achunit: "1",
        istls: "",
        iswl: "",
        nblink: "",
        nbbcc: "",
        nbattach: "",
        isout: "",
        envfrom: "",
        envrcpt: "",
        ip: "",
        attach: "",
        hdrfrom: "",
        hdrto: "",
        url: "",
        mid: "",
        subject: "",
        body: "",
        minion_host: "",
        startdate: "",
        type: "",
        spam_reason: "",
        haspass: "",
        min_size: "",
        max_size: "",
        min_size_unit: "MB",
        max_size_unit: "MB",
        min_attsize: "",
        max_attsize: "",
        min_attsize_unit: "MB",
        max_attsize_unit: "MB",
        subwhy: "",
      },
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
      xian6: true,
      xian: false,
      btnText: "展示更多",
      multipleSelection: [],
      selectList: [], // 选中的数据
      excelData: [],
      allSelect: false,
      isIndeterminate: true,

      form: {
        username: "",
      },
      // 集群节点
      minionhost: [],

      // 拦截原因
      spamreason: [],
      // 类型
      type1: [],
      // 是否放行
      haspass1: [
        {
          value: "0",
          label: "未放行",
        },
        {
          value: "1",
          label: "已放行",
        },
      ],
      istls_arr: [],
      size_unit: [
        {
          value: "MB",
          label: "MB",
        },
        {
          value: "KB",
          label: "KB",
        },
        {
          value: "B",
          label: "B",
        },
      ],
      value: "",
      value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
      fileList1: [],
      result_return_show: 0,
      q_order_type_arr: [],
      q_order_sort_arr: [],
      // 查看
      col1: [],
      // 搜索默认
      col2: {
        q_order_type: "datetime",
        q_order_sort: "desc",
        linkunit: "",
        bccunit: "",
        achunit: "",
        istls: "",
        iswl: "",
        nblink: "",
        nbbcc: "",
        nbattach: "",
        isout: "",
        envfrom: "",
        envrcpt: "",
        ip: "",
        attach: "",
        hdrfrom: "",
        hdrto: "",
        url: "",
        mid: "",
        subject: "",
        body: "",
        minion_host: "",
        startdate: "",
        type: "",
        spam_reason: "",
        haspass: "",
        min_size: "",
        max_size: "",
        min_size_unit: "",
        max_size_unit: "",
        min_attsize: "",
        max_attsize: "",
        min_attsize_unit: "",
        max_attsize_unit: "",
      },
      geng: true,
      geng1: false,
      detail_info:'',
      date_type: "",
      col_search: "",
      loading_time: "",
      page_num: "",
      authority_to_judge: [],
    };
  },

  mounted() {
    this.getFileList_1();
    this.authority_to_judge = JSON.parse(
      sessionStorage.getItem("usermsg")
    ).common;
    console.log(this.authority_to_judge);
  },
  created() {
    let that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      // console.log(e.code)

      if (
        e.code == "Enter" ||
        e.code == "Num Enter" ||
        e.code == "NumpadEnter"
      ) {
        //验证在登录界面和按得键是回车键enter
        that.tanSend(); //搜索函数
      }
    };
  },

  methods: {
    // 导出记录事件
    derived_unit() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let col_derived = JSON.parse(JSON.stringify(this.col_search));

      col_derived.limit_cn = this.limit_cn;
      col_derived.printtype = this.printtype;
      col_derived.printtofile = 1;
      let col = JSON.stringify(col_derived);

      if (this.printtype == "csv") {
        let __mode = "download_elk_archivemail";
        window.open(
          `/api/adm/cgi/elkspam.cgi?__mode=${__mode}&sid=${sid}&col=${col}&islocal=2`
        );
      }
      if (this.printtype == "html" || this.printtype == "pdf") {
        let __mode = "list_elk_archivemail";

        window.open(
          `/api/adm/cgi/elkspam.cgi?__mode=${__mode}&sid=${sid}&col=${col}&islocal=2`
        );
      }
      this.derived_show = false;
    },
    // 取消导出
    derived_cancel() {
      this.derived_show = false;
    },
    // 导出记录
    derived_record() {
      if(this.$root.jurisdiction.only_query != 0){
 this.derived_show = true;
      }
     
      this.limit_cn = this.limit_cn_old;
    },
    save_archiveforward() {
      this.is_spam = 0;
      this.islocal = 2;
      this.save_archive_forward();
    },
    copyVale(v) {
      this.$message({
        message: "复制成功,内容为：" + v,
        type: "success",
        duration: 1500,
      });
      var inputEle = document.createElement("input");
      inputEle.style.display = "none";
      inputEle.value = v;
      inputEle.select();
      document.execCommand("Copy");
      inputEle.remove();
      //  console.log(v)
    },

    // 再次投递
    data_resend() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
        this.$confirm(`${this.again_the_delivery_hint}`, {
          confirmButtonText: `${this.$t("tan.confirm")}`,
          cancelButtonText: `${this.$t("tan.cancel")}`,
          type: "warning",
        })
          .then(() => {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            var arr = this.multipleSelection;
            // console.log(arr, "全选后，获取的数组");
            let multis = [];
            for (var i = 0; i < arr.length; i++) {
              multis.push(arr[i].REC_ID);
            }
            // console.log(multis, "选中后的批量放行id");
            let multis1 = JSON.stringify(multis);
            let str = this.$qs.stringify({
              __mode: "gate_select_data_resend",
              sid: sid,

              msg_json: multis1,
            });

            this.$axios.post("/api/adm/cgi/archive.cgi", str).then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
              
                this.$message({
                  type: "success",
                  message: `${this.$t("confirm.deliver")}`,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: `${this.$t("anti_gs1_tan.del2")}`,
            });
          });
      }
    },
    // 下载
    down(a) {
      if(this.authority_to_judge.download_attach==1 && this.$root.jurisdiction.only_query != 0){

    
      // console.log( this.details);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let __mode = "download";
      console.log(__mode);

      let rec_id = this.details.rec_id;
      console.log(rec_id);

      let index = this.details.index;
      console.log(index);

      let msgtype = this.details.msgtype;
      console.log(msgtype);
      let cnt = cnt;

      console.log(a);

      window.open(
        `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}&mimeid=${a}`
      );
        }else{
           this.$message({
              
              message:`${this.$t("tan.not_pre")}`,
              type: "error",
            });
        }
    },

    // 放行
    pass() {
      this.$confirm("将放行此邮件，你确定不是垃圾邮件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.pass1();
          // this.$router.push({
          //     name: "wasteInsulate1",
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 放行条件
    pass1() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件
      let rec_id = this.details.rec_id;
      let index = this.details.index;
      let msgtype = this.details.msgtype;
      let col1 = this.col_search;
      this.$axios
        .get("/api/adm/cgi/elkspam.cgi", {
          params: {
            __mode: "pass_elkspam",
            index: index,
            sid: sid,
            rec_id: rec_id,
            is_elk: 1,
            msgtype: msgtype,
            col: col1,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.$message({
              type: "success",
              message: "放行成功!",
            });
            console.log(res);
          }
        })
        .catch((err) => {
          // console.log("接口错误");
          console.log(err);
          // alert(err);
        });
    },
    // 信头
    header() {
      // console.log( this.details);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "readmsg_header";
      // console.log(__mode);

      let rec_id = this.details.rec_id;
      // console.log(rec_id);

      let index = this.details.index;
      // console.log(index);

      let msgtype = this.details.msgtype;
      // console.log(msgtype);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(
        `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
      );
    },
    // 全部下删除
    data_delete() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
         this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
        this.loading = true;

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        console.log(sid);
        // console.log(this)
        // 获取表单数据,搜索条件
        let col = (this.col = this.col_search);
        col.totalnums = "";
        console.log(col, "传的什么啊");
        var arr = this.multipleSelection;
        // console.log(arr, "全选后，获取的数组");
        let multis = [];
        for (var i = 0; i < arr.length; i++) {
          multis.push(arr[i].SEL_ID);
        }

        // console.log(multis, "选中后的批量放行id");
        let multis1 = JSON.stringify(multis);
        let str = this.$qs.stringify({
          __mode: "elk_archive_delete",
          sid: sid,
          col: col,
          msg_json: multis1,
          islocal:2,
        });
        this.$axios
          .post("/api/adm/cgi/elkspam.cgi", str)
          .then((res) => {
            console.log(res);
            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            this.clearSelect ()
              this.getFileList_1();
            }
          })
          
          })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
      }
    },
    // 上报垃圾
    report_msg() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let rec_id = this.details.rec_id;
      let msgtype = this.details.msgtype;
      let index = this.details.index;
      let str = this.$qs.stringify({
        __mode: "report_msg",
        sid: sid,
        rec_id: rec_id,
        as_spam: 1,
        msgtype: msgtype,
        is_elk: 1,
        index: index,
      });
      this.$axios.post("/api/adm/cgi/readmsg.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          //   this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss3")}`,
          });
        }
      });
    },
    // 原始邮件
    dawdata() {
      // console.log( this.details);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let __mode = "readmsg_rawdt";
      // console.log(__mode);

      let rec_id = this.details.rec_id;
      // console.log(rec_id);

      let index = this.details.index;
      // console.log(index);

      let msgtype = this.details.msgtype;
      // console.log(msgtype);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(
        `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
      );
    },
    // 分词信息
    print() {
      this.print_show_two_elk();
    },
    // 原始正文
    original() {
      this.originol_show_to_elk();
    },
    // 正文分析
    matter() {
      this.matter_show_two_elk();
    },
    // 显示摘要
    abstract() {
      this.abstract_show_tow_elk();
    },
    // 原因分析abstract
    reason() {
      this.reason_show_to_elk();
    },
   

    yin4() {
      this.print2 = false;
      // this.abstract2 = false;
    },
    yin3() {
      this.original2 = false;
      // this.abstract2 = false;
    },
    yin2() {
      this.matter2 = false;
      // this.abstract2 = false;
    },
    yin() {
      this.reason2 = false;
      // this.abstract2 = false;
    },
    yin1() {
      // this.reason2 = false;
      this.abstract2 = false;
    },
    // 下载
    xiazai() {
      // console.log( this.details);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let __mode = "download_eml";
      console.log(__mode);

      let rec_id = this.details.rec_id;
      console.log(rec_id);

      let index = this.details.index;
      console.log(index);

      let msgtype = this.details.msgtype;
      console.log(msgtype);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(
        `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
      );
    },

    // },
    // 返回
    back() {
      console.log(this.details);
      this.col_search.totalnums = "";
      this.loading_time = 4;
      this.html = "";
      this.getFileList_2();
      this.list_two = 0;
      this.list_first = 1;

      //     setTimeout(() => {

      //     this.get_top();

      //   }, 1000);
    },
    get_top() {
      console.log("是否滚动对应元素");

      document
        .getElementById(`${this.details.rec_id}`)
        .scrollIntoView({ block: "center" });
    },
    restore_defaults() {
      this.abstract2 = false;
      this.reason2 = false;
      this.matter2 = false;
      this.original2 = false;
      this.print2 = false;
      this.detail_show = false;

    },
    // 数据

    getFileList() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      console.log(this.details);
      // 获取表单数据,搜索条件
      let rec_id = this.details.rec_id;
      let index = this.details.index;
      let msgtype = this.details.msgtype;
      let col1 = this.details.col1;
      // let  recid= this.details
      // console.log(rec_id);
      // console.log(msgtype);
      //
      this.$axios
        .get("/api/adm/cgi/readmsg.cgi", {
          params: {
            __mode: "readmsg_sum",
            index: index,
            sid: sid,
            rec_id: rec_id,
            is_elk: 1,
            msgtype: msgtype,
            CONDITION_COL: col1,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);

          // console.log(res.data.fmstatus.code);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
            this.loading = false;
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            // this.list_first = 1;
            // this.list_two = 0;
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            //  alert(55555)
            alert(res.data.fmstatus.errmsg);
            // this.list_first = 1;
            // this.list_two = 0;
            this.loading = false;
          } else {
            this.restore_defaults();
            document.getElementById("detail_type").scrollIntoView(true);

            this.list_first = 0;
            this.list_two = 1;

            setTimeout(function () {
              let top_style = document.getElementById("main_btn").offsetHeight;
              this.top_style_height = top_style;
              console.log(this.top_style_height);
              document.getElementById("main_btn1").style.marginTop =
                this.top_style_height + "px";
            }, 300);
 this.detail_info=res.data.ret.DETAIL_INFO;
            //  显示摘要，正文分析
            this.abstract_show = res.data.ret.SYS_SHOW_DIGEST;
            //  原始正文
            this.original_show = res.data.ret.SYS_SHOW_ORIGINAL_BODY;
            //分词信息
            this.print_show = res.data.ret.SYS_SHOW_PAETICIPLE_INFO;
            // 垃圾训练，正常训练
            this.trainspam_show = res.data.ret.SYS_SELF_BUILD_BAYES_ON;
            // 删除
            this.delect_show = res.data.ret.SYS_GATE_DATA_CAN_DELETE;
            // 上报垃圾
            this.readmsg_show = res.data.ret.SYS_FARCHIVE_AS_SPAM;
            this.fileList = res.data.ret;
            this.fujian = res.data.ret.datalist;
            // this.fnameage=this.fujian.length
            if (res.data.ret.datalist) {
              let a = 0;
              for (let i = 0; i <= this.fujian.length; i++) {
                a = i;
              }
              this.fnameage = a;
              this.fname = res.data.ret.datalist[0].NAME;
            }
            // console.log(this.fujian.length)
            // console.log(a)

            // console.log(this.fname);
            this.html = res.data.ret.BODY;
            this.html1 = res.data.ret.SUBJECT;
            this.loading = false;

            // 分词信息
            // this.$axios
            //     .get("/api/adm/cgi/readmsg.cgi", {
            //         params: {
            //             __mode: "printparticipleinfo",
            //             index: index,
            //             sid: sid,
            //             rec_id: rec_id,
            //             is_elk: 1,
            //             msgtype: msgtype,

            //         },
            //     })
            //     .then((res) => {

            //         this.print1 = res.data.ret.PAETICIPLE_INFO;
            //     })
            //     .catch((err) => {

            //         console.log(err);

            //     });
            // 原始正文
            // this.$axios
            //     .get("/api/adm/cgi/readmsg.cgi", {
            //         params: {
            //             __mode: "printoriginalbody",
            //             index: index,
            //             sid: sid,
            //             rec_id: rec_id,
            //             is_elk: 1,
            //             msgtype: msgtype,
            //             // screen: "real_filterlog.html",
            //         },
            //     })
            //     .then((res) => {
            //         // console.log(res);
            //         this.original1 = res.data.ret.ORIG_BODY;
            //     })
            //     .catch((err) => {
            //         // console.log("接口错误");
            //         console.log(err);
            //         // alert(err);
            //     });
            // 原因分析
            // this.$axios
            //     .get("/api/adm/cgi/readmsg.cgi", {
            //         params: {
            //             __mode: "view_reason",
            //             index: index,
            //             sid: sid,
            //             rec_id: rec_id,
            //             is_elk: 1,
            //             msgtype: msgtype,
            //             // screen: "real_filterlog.html",
            //         },
            //     })
            //     .then((res) => {
            //         // console.log(res)
            //         this.reason1 = res.data.ret.REASON;
            //     })
            //     .catch((err) => {
            //         // console.log("接口错误");
            //         console.log(err);
            //         // alert(err);
            //     });
            // this.$axios
            //     .get("/api/adm/cgi/readmsg.cgi", {
            //         params: {
            //             __mode: "showdigest",
            //             index: index,
            //             sid: sid,
            //             rec_id: rec_id,
            //             is_elk: 1,
            //             msgtype: msgtype,
            //             // screen: "real_filterlog.html",
            //         },
            //     })
            //     .then((res) => {
            //         // console.log(res)

            //         this.abstract1 = res.data.ret.DIGEST;

            //         // console.log( this.html)
            //     })
            //     .catch((err) => {
            //         // console.log("接口错误");
            //         console.log(err);
            //         // alert(err);
            //     });
            // this.$axios
            //     .get("/api/adm/cgi/readmsg.cgi", {
            //         params: {
            //             __mode: "printnumemail",
            //             index: index,
            //             sid: sid,
            //             rec_id: rec_id,
            //             is_elk: 1,
            //             msgtype: msgtype,
            //             // screen: "real_filterlog.html",
            //         },
            //     })
            //     .then((res) => {
            //         // console.log(res);

            //         this.matter1 = res.data.ret.DETAIL;
            //     })
            //     .catch((err) => {
            //         // console.log("接口错误");
            //         console.log(err);
            //         // alert(err);
            //     });
          }
        });
      // .catch((err) => {
      //     // console.log("接口错误");
      //     console.log(err);
      //     alert(err);
      // });
    },
    // email移出黑名单
    tan11() {
      this.$confirm(`${this.$t("tan.tan11")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = this.fileList.ENVFROM;
          console.log(dnoremail);

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_blsender",
                dnoremail: dnoremail,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm2")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel2")}`,
          });
        });
    },
    //  email移出白名单
    tan12() {
      this.$confirm(`${this.$t("tan.tan12")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = this.fileList.ENVFROM;
          console.log(dnoremail);

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_wlsender",
                dnoremail: dnoremail,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm2")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel2")}`,
          });
        });
    },
    //  ip移出黑名单
    tan13() {
      this.$confirm(`${this.$t("tan.tan13")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let ipaddr = this.fileList.PEER_IP;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_ipbl",
                blip: ipaddr,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm2")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel2")}`,
          });
        });
    }, //  ip移出白名单
    tan14() {
      this.$confirm(`${this.$t("tan.tan14")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let ipaddr = this.fileList.PEER_IP;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_ipwl",
                wlip: ipaddr,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm2")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel2")}`,
          });
        });
    },
    // 弹框
    tan1() {
      // var b
      this.$confirm(`${this.$t("tan.tan1")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = this.fileList.ENVFROM;
          console.log(dnoremail);

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "save_blsender",
                dnoremail: dnoremail,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              // console.log(res)
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm1")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel1")}`,
          });
        });
    },
    // 弹框
    tan2() {
      this.$confirm(`${this.$t("tan.tan2")}`, "提示", {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = this.fileList.ENVFROM;
          console.log(dnoremail);

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "save_wlsender",
                dnoremail: dnoremail,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm1")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel1")}`,
          });
        });
    },

    // 弹框
    tan3() {
      // var b

      this.$confirm(`${this.$t("tan.tan3")}`, "提示", {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let ipaddr = this.fileList.PEER_IP;
          // console.log(dnoremail);

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "save_ipbl",
                ipaddr: ipaddr,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm1")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel1")}`,
          });
        });
    },
    // 弹框
    tan4() {
      // var b

      this.$confirm(`${this.$t("tan.tan4")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let ipaddr = this.fileList.PEER_IP;
          // console.log(dnoremail);

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "save_ipwl",
                ipaddr: ipaddr,

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.$message({
                  type: "success",
                  message: `${this.$t("tan.confirm1")}`,
                });
                this.getFileList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel1")}`,
          });
        });
    },
    // 下一封

    next_email() {
      this.loading_time = 2;

      let page_num = Math.floor((this.totalnums + this.size - 1) / this.size);
      this.page_num = page_num;
      //    console.log(page_num)
      if (
        this.details.INDEX_ID == this.fileList1.length - 1 &&
        this.page == page_num
      ) {
        this.$message({
          type: "success",
          message: `${this.$t("logs.next_mail")}`,
        });
      } else {
        if (
          this.details.INDEX_ID == this.fileList1.length - 1 &&
          this.page < page_num
        ) {
          this.loading = true;
          this.col = this.col_search;
          this.col.page = this.col.page + 1;

          this.getFileList_2(); //加载下一页的数据
          // setTimeout(() => {
          //   this.load_next_time(), console.log(99);
          // }, 3000);
        } else {
          let row = this.fileList1[this.details.INDEX_ID + 1];
          console.log(row, "这是第几风");
          console.log(this.page, "第xxx  页");
          this.details.rec_id = row.REC_ID;
          this.details.index = row.INDEX;
          this.details.msgtype = row.MSGTYPE;
          this.details.INDEX_ID = row.INDEX_ID;
          this.getFileList();
        }
      }
    },
    // 上一封
    up_email() {
      this.loading_time = 1;
      if (this.details.INDEX_ID == 0 && this.page == 1) {
        console.log(this.page, "第一页，");
        this.$message({
          type: "success",
          message: `${this.$t("logs.up_mail")}`,
        });
      } else {
        if (this.details.INDEX_ID == 0 && this.page > 1) {
          this.loading = true;
          this.col = this.col_search;
          this.col.page = this.col.page - 1;

          this.getFileList_2(); //加载上一页的数据
          // setTimeout(() => {
          //   this.load_up_time(), console.log(99);
          // }, 3000);
        } else {
          console.log(this.page, "第xxx  页");

          // console.log(this.fileList1, "有诶有数据呢");
          console.log(this.details, "details", this.details.INDEX_ID - 1);
          let row = this.fileList1[this.details.INDEX_ID - 1];
          console.log(row, "这是第几封");

          this.details.rec_id = row.REC_ID;
          this.details.index = row.INDEX;
          this.details.msgtype = row.MSGTYPE;
          this.details.INDEX_ID = row.INDEX_ID;
          this.getFileList();
        }
      }
    },
    // 删除当前邮件
    readmsg_sum() {
      let page_num = Math.floor((this.totalnums + this.size - 1) / this.size);
      this.page_num = page_num;
      console.log(this.details, "details", this.details.INDEX_ID - 1);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let rec_id = this.details.rec_id;
          let msgtype = this.details.msgtype;
          let index = this.details.index;
          let str = this.$qs.stringify({
            __mode: "readmsg_sum",
            sid: sid,
            rec_id: rec_id,
            is_next: 3,
            msgtype: msgtype,
            index: index,
            is_elk: 1,
          });
          this.$axios.post("/api/adm/cgi/readmsg.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              //   this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              let delect_hin = 0;

              if (delect_hin == 0) {
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
              console.log(this.details.INDEX_ID);
              this.fileList1.splice(this.details.INDEX_ID, 1);
              console.log(this.fileList1, "删除后的数据");
              for (let i = 0; i < this.fileList1.length; i++) {
                this.fileList1[i].INDEX_ID = i;
                // console.log( this.fileList1[i].INDEX_ID)
              }

              if (
                // 当前页  第一封  当前页  数组长度为0，page 不是第一页
                this.details.INDEX_ID == 0 &&
                this.fileList1.length == 0 &&
                this.page < page_num
              ) {
                // this.col_search.page = this.col.page - 1;
                this.col_search.totalnums = "";
                this.loading_time = 5;
                // alert("下一页的数据 ,id=0", this.page, this.details.INDEX_ID);
                console.log(this.page, "this.page_num", this.page_num);
                this.getFileList_2();
              } else if (
                // 当前页 最后一封   id =  长度 ，有下一页
                this.details.INDEX_ID == this.fileList1.length &&
                this.page < page_num
              ) {
                this.col_search.totalnums = "";

                console.log(this.page, "this.page_num", this.page_num);
                // alert("下一页的数据", this.page, this.details.INDEX_ID);

                this.loading_time = 5;

                this.getFileList_2();
              } else if (
                // 当前页  第一封               当前页  数组长度为0，说明没有数据
                this.details.INDEX_ID == 0 &&
                this.fileList1.length == 0 &&
                this.page == 1
              ) {
                delect_hin = 1;
                this.back();

                if (delect_hin == 1) {
                  this.$message({
                    type: "success",
                    message: `${this.$t("anti_gs1_tan.del4")}`,
                  });
                }
              } else if (
                // 当前页  第一封   当前页  数组长度为0，说明没有数据  还有页数
                this.details.INDEX_ID == 0 &&
                this.fileList1.length == 0 &&
                this.page == page_num
              ) {
                this.col_search.page = this.col_search.page - 1;
                this.col_search.totalnums = "";
                // alert("到上一页最后一封", this.page, this.details.INDEX_ID);

                this.loading_time = 1;
                //加载下一页的数据

                this.getFileList_2();
                console.log(this.page, "this.page_num", this.page_num);
              } else if (
                // 当前页  最后一封  id =  长度  如果 在最后一页，，
                this.details.INDEX_ID == this.fileList1.length &&
                this.page == page_num
              ) {
                // alert("最后一页，的上一条");
                this.loading_time = 1;
                //加载下一页的数据

                this.getFileList_2();
                console.log(this.page, "this.page_num", this.page_num);
              } else {
                // alert("下一封", this.page);
                console.log(
                  this.page,
                  "this.page_num",
                  this.page_num,
                  this.details.INDEX_ID
                );
                this.next_email_del();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    //删除后的下一封
    next_email_del() {
      let row = this.fileList1[this.details.INDEX_ID];
      console.log(row, "这是第几风");
      console.log(this.page, "第xxx  页");
      this.details.rec_id = row.REC_ID;
      this.details.index = row.INDEX;
      this.details.msgtype = row.MSGTYPE;
      this.details.INDEX_ID = row.INDEX_ID;
      this.getFileList();
    },
    // 删除后的翻页，index id  应该是和翻页前相同
    load_up_time_next() {
      let row = this.fileList1[this.details.INDEX_ID];

      console.log(row, "这是第当前页最后一封吗");
      this.details.rec_id = row.REC_ID;
      this.details.index = row.INDEX;
      this.details.msgtype = row.MSGTYPE;
      this.details.INDEX_ID = row.INDEX_ID;
      // this.getFileList();
      setTimeout(() => {
        this.getFileList(), console.log(99);
      }, 100);
    },
    // 下一页第一封
    load_next_time() {
      let row = this.fileList1[0];

      console.log(row, "这是第当前页最后一封吗");
      this.details.rec_id = row.REC_ID;
      this.details.index = row.INDEX;
      this.details.msgtype = row.MSGTYPE;
      this.details.INDEX_ID = row.INDEX_ID;
      // this.getFileList();
      setTimeout(() => {
        this.getFileList(), console.log(99);
      }, 100);
    },
    // 上一页最后一封
    load_up_time() {
      let row = this.fileList1[this.fileList1.length - 1];

      console.log(row, "这是第当前页最后一封吗");
      this.details.rec_id = row.REC_ID;
      this.details.index = row.INDEX;
      this.details.msgtype = row.MSGTYPE;
      this.details.INDEX_ID = row.INDEX_ID;
      // this.getFileList();
      setTimeout(() => {
        this.getFileList(), console.log(99);
      }, 100);
    },
    // 每行点击
    addSubAccount(row) {
      
      console.log(row);

      (this.details.INDEX_ID = row.INDEX_ID),
        (this.details.rec_id = row.REC_ID),
        (this.details.index = row.INDEX),
        (this.details.msgtype = row.MSGTYPE),
        (this.details.col1 = this.col1),
        console.log(this.details, "this.details,这是传的数据");
      // this.list_first=0
      // this.list_two=1
      //
      this.abstract2 = false;
      this.reason2 = false;
      this.matter2 = false;
      this.original2 = false;
      this.print2 = false;
      if (this.authority_to_judge.read == 1) {
        this.loading = true;
        this.getFileList();
      } else {
        this.$message({
          message: `${this.$t("tan.reading_pre")}`,
          type: "error",
        });
      }
    },
    // 批量放行

    bulkpass() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
        this.loading = true;

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        console.log(sid);
        // console.log(this)
        // 获取表单数据,搜索条件
        let col = this.col;

        var arr = this.multipleSelection;
        // console.log(arr, "全选后，获取的数组");
        let multis = [];
        for (var i = 0; i < arr.length; i++) {
          multis.push(arr[i].SEL_ID);
        }
        console.log(multis, "选中后的批量放行id");
        let multis1 = JSON.stringify(multis);
        this.$axios
          .get("/api/adm/cgi/elkspam.cgi", {
            params: {
              __mode: " elk_archive_delete",
              sid: sid,
              col: col,

              // bulkpassflag: 1,
              msg_json: multis1,
              // screen: "real_filterlog.html",
            },
          })
          .then((res) => {
            console.log(res);
            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.fileList1 = res.data.ret.datalist;

              this.totalnums = res.data.ret.col.totalnums;
              this.size = res.data.ret.col.pagesize;
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log("接口错误");
            console.log(err);
            alert(err);
          });
      }
    },

    // 全部下载
    openPostWindow() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
          this.$confirm(`${this.$t("anti_gs1_tan.down_load")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
        var arr = this.multipleSelection;
        console.log(arr, "全选后，获取的数组");
        let multis = [];
        for (var i = 0; i < arr.length; i++) {
          multis.push(arr[i].SEL_ID);
        }
        // console.log(multis, "选中后的id");

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        var tempForm = document.createElement("form");
        tempForm.id = "tempForm1";
        tempForm.method = "post";
        tempForm.action = "/api/adm/cgi/elkspam.cgi?";
        tempForm.target = "_blank"; //打开新页面
        var hideInput1 = document.createElement("input");
        hideInput1.type = "hidden";
        hideInput1.name = "__mode"; //后台要接受这个参数来取值
        hideInput1.value = "elk_archive_downzip"; //后台实际取到的值
        var hideInput2 = document.createElement("input");
        hideInput2.type = "hidden";
        hideInput2.name = "sid";
        hideInput2.value = `${sid}`;
        var hideInput3 = document.createElement("input");
        hideInput3.type = "hidden";
        hideInput3.name = "msg_json";
        hideInput3.value = `${multis}`;
         var hideInput4 = document.createElement("input");
        hideInput4.type = "hidden";
        hideInput4.name = "islocal";
        hideInput4.value = '2';
        // 这里就是如果需要第二个参数的时候可以自己再设置;
        tempForm.appendChild(hideInput1); //tempForm.appendChild(hideInput2);
        tempForm.appendChild(hideInput2); //tempForm.appendChild(hideInput2);
        tempForm.appendChild(hideInput3); //tempForm.appendChild(hideInput2);
        tempForm.appendChild(hideInput4); //tempForm.appendChild(hideInput2);
        if (document.all) {
          tempForm.attachEvent("onsubmit", function () {}); //IE
        } else {
          // var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
        }
        document.body.appendChild(tempForm);
        if (document.all) {
          tempForm.fireEvent("onsubmit");
        } else {
          tempForm.dispatchEvent(new Event("submit"));
        }
        tempForm.submit();
        // console.log(tempForm, 'xiazai')

        document.body.removeChild(tempForm);
         })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.down_load_cancel")}`,
          });
        });

      }
       
      
    },

    downloadExcel() {
      this.$confirm("确定下载列表文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.excelData = this.selectData; //你要导出的数据list。
          this.exportExcel();
        })
        .catch(() => {});
    },

    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          //设置导出文件名称
          "sheetjs.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    //  getdatatime() {
    //   //默认显示今天
    //   this.value2 = new Date();
    // },
    // 格式化时间，获取当前时间的一个月后的时间值
    Date() {
      var seperator1 = "-";

      var data = new Date();
      var Da = new Date(data.getTime());
      // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
      // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
      // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
      // var Da = new Date()
      var year = Da.getFullYear();
      var month = Da.getMonth() + 1;
      var hour = Da.getHours();
      var minutes = Da.getMinutes();
      var seconds = Da.getSeconds();
      var strDate = Da.getDate();

      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (seconds >= 1 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      return (
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    // 七天前日期
    convertToLateDate() {
      var data = new Date();
      var Da = new Date(data.getTime() - 24 * 60 * 60 * 1000 * 7);
      var seperator1 = "-";
      // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
      // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
      // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
      // var Da = new Date()
      // var y = Da.getFullYear();
      // var m = Da.getMonth() + 1;
      // var d = Da.getDate();
      // var H = Da.getHours();
      // var mm = Da.getMinutes();
      // m = m < 10 ? "0" + m : m;
      // d = d < 10 ? "0" + d : d;
      // H = H < 10 ? "0" + H : H;
      // return y + "-" + m + "-" + d + " " + H + ":" + mm;
      var year = Da.getFullYear();
      var month = Da.getMonth() + 1;
      var hour = Da.getHours();
      var minutes = Da.getMinutes();
      var seconds = Da.getSeconds();
      var strDate = Da.getDate();
      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (seconds >= 1 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      return (
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    //打包下载
    // speedupCheckbox() {
    //   if (this.multipleSelection.length === 0) {
    //     this.$message({
    //       message: "请至少勾选一项，再进行操作",
    //       type: "warning",
    //     });
    //     return;
    //   } else {
    //     // this. openPostWindow()
    //     // this.speedupData();
    //     // this.exportExcel();
    //   }
    // },
    // 表格选中值
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection, "table 框选中的值");
      // console.log(this.table);
    },
    getRowKeys(row) {
      //  console.log(row.INDEX_ID)
      return row.REC_ID; // id为列表数据的唯一标识
    },
    // 清空选择的值
    clearSelect() {
      this.$refs.multipleTable.clearSelection();
    },

    //全选
    speedupData() {
      var arr = this.multipleSelection;
      // console.log(arr, "全选后，获取的数组");
      let multis = [];
      for (var i = 0; i < arr.length; i++) {
        multis.push(arr[i].SEL_ID);
      }
      console.log(multis, "选中后的id");

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      // let msg=JSON.stringify(multis)
      let __mode = "elk_spam_downzip";
      console.log(__mode);

      this.$refs.multipleTable.clearSelection(); //操作完成清除勾选框
    },

    // 更多
    xians: function () {
      this.xian = !this.xian;

      if (this.xian) {
        this.geng = false;
        this.geng1 = true;
      } else {
        this.geng = true;
        this.geng1 = false;
      }
    },
    // 页面加载完成时，
    getFileList_2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      let col = this.col_search;
      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/elkspam.cgi", {
          params: {
            __mode: " list_elk_archivemail",
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
         
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.restore_defaults();
            this.fileList1 = res.data.ret.datalist;
            // 总条数
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;

            this.col_search = res.data.ret.col;
            this.$nextTick(() => {
              this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            });
            if (this.loading_time == 2) {
              this.load_next_time();
            } else if (this.loading_time == 1) {
              this.load_up_time();
            } else if (this.loading_time == 3) {
              this.load_up_time();
            } else if (this.loading_time == 4) {
              this.loading = false;

              setTimeout(() => {
                this.get_top();
              }, 10);
            } else if (this.loading_time == 5) {
              this.load_up_time_next();
            }
          }
        });
    },
    // 数据

    getFileList_1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件
 this.col.islocal=2;
      let col = this.col;
      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/elkspam.cgi", {
          params: {
            __mode: " list_elk_archivemail",
            sid: sid,
            col: col,
            islocal:2,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;

           
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
             this.limit_cn_old=res.data.ret.col.limit_cn
             this.printtype_arr = res.data.ret.q_printtype;
            this.data_can_delete_show = res.data.ret.SYS_GATE_DATA_CAN_DELETE;
            this.all_show_more_show = res.data.ret.SHOW_MORE_ACTION;
            this.all_download_show = res.data.ret.SYS_FARCHIVE_ALLDATA_DOWNLOAD;
            this.again_the_delivery_show =
              res.data.ret.SYS_FARCHIVE_DATA_RESEND;
            this.archive_forward_show = res.data.ret.SYS_FARCHIVE_DATA_FORWORD;
            this.data_forword = res.data.ret.data_forword;
            this.data_forword_address = res.data.ret.data_forword_address;
            this.all_download = res.data.ret.down_all;
            this.fileList1 = res.data.ret.datalist;
            // 总条数
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.linkunti = res.data.ret.col.linkunti;
            this.bccunti = res.data.ret.col.bccunti;
            this.athunti = res.data.ret.col.athunti;
            // console.log(this.page)
            this.minionhost = res.data.ret.q_minion_host;
            // this.type1 = res.data.ret.q_spam_reason;
            // 节点
            this.minionhost = res.data.ret.q_minion_host;
            //  类型
            this.type1 = res.data.ret.q_type;
            //  原因
            this.spamreason = res.data.ret.q_spam_reason;
            this.loading = false;

            // for (let i = 0; i < this.fileList1.length; ++i) {
            //     this.fileList1[i].SHOW_MORE = '展示更多'
            // }
            // var vm = this;
            // 页面加载完成后渲染日期
            if (this.search_time == 0) {
              this.col.startdate = res.data.ret.q_date;
            }
            this.q_order_type_arr = res.data.ret.q_order_type;
            this.q_order_sort_arr = res.data.ret.q_order_sort;
            this.date_type = res.data.ret.col.startdate;
            this.col_search = res.data.ret.col;
            this.istls_arr = res.data.ret.q_yes_no;
            console.log(this.col_search, "后台返回数据col");
            this.$nextTick(() => {
              this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            });
            // console.log(this.col.startdate);
          }
        });
    },
    // 打开搜素
    tanSend() {
      if (this.geng1 == true) {
        this.geng = true;
        this.geng1 = false;
        this.xian = false;
      }
      this.loading = true;
      // this.page = 1
      const col = {
        order_type: this.col.q_order_type,
        order_sort: this.col.q_order_sort,
        linkunit: this.col.linkunit,
        bccunit: this.col.bccunit,
        achunit: this.col.achunit,
        istls: this.col.istls,
        iswl: this.col.iswl,
        nblink: this.col.nblink,
        nbbcc: this.col.nbbcc,
        nbattach: this.col.nbattach,
        isout: this.col.isout,
        subject: this.col.subject,
        url: this.col.url,
        envfrom: this.col.envfrom,
        envrcpt: this.col.envrcpt,
        mid: this.col.mid,
        ip: this.col.ip,
        attach: this.col.attach,
        hdrfrom: this.col.hdrfrom,
        hdrto: this.col.hdrto,
        body: this.col.body,
        type: this.col.type,
        haspass: this.col.haspass,
        min_size: this.col.min_size,
        max_size: this.col.max_size,
        min_size_unit: this.col.min_size_unit,
        max_size_unit: this.col.max_size_unit,
        min_attsize: this.col.min_attsize,
        max_attsize: this.col.max_attsize,
        min_attsize_unit: this.col.min_attsize_unit,
        max_attsize_unit: this.col.max_attsize_unit,
        spam_reason: this.col.spam_reason,
        startdate: this.col.startdate,
        minion_host: this.col.minion_host,
        page: 1,
        pagesize: this.size,
         islocal:2,
      };
      let col2 = col;
      // console.log(col2, "搜索传值");
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      this.$axios
        .get("/api/adm/cgi/elkspam.cgi", {
          params: {
            __mode: "list_elk_archivemail",
            sid: sid,
            col: col2,
          },
        })
        .then((res) => {
          // this.loading = true;
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            setTimeout(() => {
              alert(res.data.fmstatus.errmsg);
            }, 100);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            console.log(res);
            // this.col1 = this.col;
            // let col1 = this.col1;
            // console.log(col1);
            // this.page = 1
            // this.pagesize = 50
            // this.xian=false
            this.search_time = 1;
            this.fileList1 = res.data.ret.datalist;
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.loading = false;

            this.col_search = res.data.ret.col;
            this.clearSelect();
            console.log(this.col_search, "后台返回数据col，搜索后");
          }
        });

      // 值清空
      // this.subject = "";
      // this.ip = "";

      // (this.envfrom = ""),
      //   (this.envrcpt = ""),
      //   (this.id = ""),
      //   (this.spam_reason = ""),
      //   (this.startdate = ""),
      //   (this.minion_host = ""),
      //   console.log(this.ip);
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },

    // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.pagesize = val;

      console.log(this.col, "给后台返回数据2");

      this.getFileList_1();
      this.clearSelect();
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.page = val;
      console.log(this.col, "给后台返回数据2");

      this.getFileList_1();
      this.clearSelect();
    },
    handleCurrentChange2(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      //  this.tanSend(this.search,this.pagesize)
      // console.log(this.page, '2', val);
    },
    // 打开详情页
    handleEdit(index, row) {
      // console.log(this.col1);
      console.log(index, row);
      // this.loading = false;

      this.$router.push({
        name: "guiDangListOne1",
        params: {
          rec_id: row.REC_ID,
          index: row.INDEX,
          msgtype: row.MSGTYPE,
          is_elk: 1,
          col1: this.col1,
        },
      });
    },
    // 收件人展示更多

    handleEdit1(index, row) {
      console.log(row);
      this.fileList1[index].SHOW_MORE =
        row.SHOW_MORE == `${this.$t("table.show")}`
          ? `${this.$t("table.yin")}`
          : `${this.$t("table.show")}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/breadcrumb.less";

@import "../../css/liebiao.less";
@import "../../css/list_detail.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

// /deep/ .warning-row {
//   background: #f2f6fb;
// }

// /deep/ .success-row {
//   background: #fff;
// }
/deep/ .el-table__body tr:hover {
  cursor: pointer;
}

/deep/.el-table__row td:nth-child(2) {
  .cell {
    padding-left: 0px;
    display: flex;
    justify-content: space-around;
  }
}
/deep/.el-table--enable-row-hover .el-table__body .result_return > td {
  background: #99ccff !important;
}
.tooltio_subject {
  max-width: 400px !important;
}
.show_style_drop{
margin-bottom: 0px;
}
/deep/ .has-gutter th {
  text-align: left;
  .cell{
  text-align: left;

  }
}

/deep/.el-table__row td{
    .cell {
        text-align: left;
    }

    text-align: left;
}
/deep/ .has-gutter th:nth-child(1),/deep/.el-table__row td:nth-child(1){
      .cell{
  text-align: center;

  }
}
</style>
